import useMediaQuery from '@package/hooks/src/useMediaQuery';
import { useEffect } from 'react';

import MenuBody from './components/MenuBody';
import { MenuProps } from './types';

const Menu = ({ menuData, url, isMenuOpen, handleOpenMenu, topPosition }: MenuProps) => {
  const mobile: boolean = useMediaQuery('(max-width:1279px)');
  useEffect(() => {
    if (document) {
      const htmlRoot = document?.querySelector('html');
      if (isMenuOpen) {
        if (mobile && window.scrollY < topPosition) {
          window.scrollTo({ top: 0 });
        }
        htmlRoot?.classList.add('preventScroll');
      } else {
        htmlRoot?.classList.remove('preventScroll');
      }
    }
  }, [isMenuOpen]);

  return (
    <MenuBody
      menuData={menuData}
      isMenuOpened={isMenuOpen}
      handleCloseMenu={() => handleOpenMenu(false)}
      handleOpenMenu={() => handleOpenMenu(true)}
      mobile={mobile}
      mainUrl={url}
      topPosition={topPosition}
    />
  );
};

export default Menu;
